<!--
  ~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
  -->

<div class="message--container" [class.no-icon]="!showClose">
  @if (showIcon) {
    <mat-icon></mat-icon>
  }
  <div>
    <ng-content></ng-content>
    @if (showClose) {
      <button type="button" class="close" aria-label="Dismiss message" (click)="close.emit()">x</button>
    }
  </div>
</div>
